export const MOVE_POSITION = 'MOVE_POSITION';

export const movePosition = intPosition => {
  return {
    type: MOVE_POSITION,
    payload: intPosition 
  } 
};


// WEBPACK FOOTER //
// ./src/actions/positionActions.js